/**
 * Asks the adviser about a document's warnings (owner, Nov 2 2026). Every Word path ends in a service, not a
 * component, so the one dialog (DocumentWarningPrompt.jsx, mounted with the app) registers itself here.
 * With no dialog mounted the answer is no, so a document with a warning is never made unseen.
 */
let prompt = null;

export function setDocumentWarningPrompt(next) {
  prompt = next;
  return () => { if (prompt === next) prompt = null; };
}

/** @param {{ message: string, ifProceeded?: string }[]} warnings @returns {Promise<boolean>} proceed? */
export async function confirmDocumentWarnings(warnings) {
  if (!prompt || !Array.isArray(warnings) || warnings.length === 0) return false;
  return (await prompt(warnings)) === true;
}

export const acceptedWarningTexts = (warnings) => (warnings || []).map((w) => w.message);
